import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';

/**
 * CustomButton component that disables itself for a configurable time after being clicked.
 * @param {import('@mui/material').ButtonProps & { disableDuration?: number }} props - Props inherited from Material-UI Button with additional disableDuration prop
 * @returns {JSX.Element}
 */
const CustomButton = ({ disableButton = true, disableDuration = 2000, ...props }) => {
    const [isDisabled, setIsDisabled] = useState(false);

    const handleClick = (event) => {
        // If there's an onClick prop, call the passed onClick handler
        if (props.onClick) {
            props.onClick(event);
        }

        // Disable the button after clicking
        disableButton && setIsDisabled(true);
    };

    useEffect(() => {
        if (isDisabled) {
            const timer = setTimeout(() => {
                setIsDisabled(false); // Re-enable the button after the specified duration
            }, disableDuration);

            return () => clearTimeout(timer); // Cleanup timer on unmount
        }
    }, [isDisabled, disableDuration]);

    return (
        <Button
            style={{ textWrap: 'nowrap', ...(props.style || {}) }}
            {...props} // Spread all other props like 'variant', 'color', etc.
            disabled={isDisabled || props.disabled} // Disable button based on internal state or passed prop
            onClick={handleClick} // Handle click
        >
            {props.children}
        </Button>
    );
};

export default CustomButton;